import { Layout } from 'antd';
import styled from 'styled-components';
import { Button as StyledButton, Button2 } from '../../../../styles/buttons';

export const Container = styled(Layout)`
  padding: 0.5rem 1rem;
  gap: 1rem;
  position: relative;

  @media (min-width: 768px) {
    padding: 1rem 2rem;
  }
`;

/* Grid responsivo: 1 col (mobile), 2 cols (tablet), 4 cols (desktop) */
export const FormGrid = styled.div`
  width: 100%;
  max-width: 960px;
  margin-top: 0.75rem;
  display: grid;
  gap: 12px;

  grid-template-columns: 1fr; /* mobile */

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, minmax(220px, 1fr)); /* tablet */
  }

  @media (min-width: 1024px) {
    /* 4 inputs + 1 coluna pro botão (largura fixa/auto) */
    grid-template-columns: repeat(4, minmax(200px, 1fr)) 180px;
  }
`;

/* Wrapper com sufixo/prefixo posicionados */
export const InputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  /* garante que todos fiquem com largura consistente na linha */
  width: 100%;

  input {
    width: 100%;
    height: 40px;
    padding: 8px 36px 8px 12px; /* espaço pro sufixo % */
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    background: #fff;
    color: #111;
    font-size: 14px;
    outline: none;
    transition: all 0.15s ease;

    &::placeholder {
      color: #9aa0a6;
    }

    &:hover {
      border-color: #bfbfbf;
    }
    &:focus {
      border-color: #1677ff; /* cor padrão Ant */
      box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.15);
    }
  }

  /* Sufixo % — dentro do input, à direita */
  .suffix {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    color: #6b7280;
    font-weight: 500;
    font-size: 14px;
  }

  /* Prefixo R$ — para o campo de valor */
  &.currency {
    .prefix {
      position: absolute;
      left: 10px;
      top: 50%;
      transform: translateY(-50%);
      color: #6b7280;
      font-weight: 500;
      font-size: 14px;
      pointer-events: none;
    }
    input {
      padding-left: 34px; /* espaço pro "R$" */
    }
  }
`;

export const TableCard = styled.div`
  width: 100%;
  max-width: 960px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 16px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
`;

/* Grid responsivo com espaçamento e proporção */
export const FeeGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

/* Cada bloco de taxa */
export const FeeItem = styled.div`
  background: #f9fafb;
  border-radius: 8px;
  padding: 10px 12px;
  border: 1px solid #e5e7eb;
  text-align: center;
  transition: all 0.2s ease;

  &:hover {
    background: #f3f4f6;
    border-color: #d1d5db;
  }
`;

export const FeeLabel = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: #6b7280;
  margin-bottom: 4px;
`;

export const FeeValue = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #111827;
`;

export const Button = styled(Button2)`
  margin: 0;
  width: 200px;
  height: 40px;
`;
